import { ChangeDetectionStrategy, Component, forwardRef, inject, Input } from '@angular/core';
import { ModalHeaderComponent } from '@base/components/private/modals/modal-header/modal-header.component';
import { ModalBodyComponent } from '@base/components/private/modals/modal-body/modal-body.component';
import { ModalFooterComponent } from '@base/components/private/modals/modal-footer/modal-footer.component';
import { TranslatePipe } from '@base/pipes/private/translate.pipe';
import { ModalService } from '@base/services/private/modal.service';
import { ThemeService } from '@base/services/private/theme.service';

@Component({
  selector: 'app-modal-confirmation-ai',
  imports: [ModalHeaderComponent, ModalBodyComponent, ModalFooterComponent, forwardRef(() => TranslatePipe)],
  templateUrl: './modal-confirmation-ai.component.html',
  styleUrl: './modal-confirmation-ai.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalConfirmationAiComponent {
  private readonly modalSrv = inject(ModalService);
  private readonly themeSrv = inject(ThemeService);

  @Input() modalId = 'modal-ai-confirmation';
  @Input() resultFound: string | null = null;
  @Input() resultFoundDesc: string | null = null;

  isBgDarkMode = this.themeSrv.isBgDarkMode;

  /**
   * Closes the modal and returns true.
   */
  confirm(): void {
    this.modalSrv.close(this.modalId, { key: 'confirm', value: true });
  }

  /**
   * Closes the modal and returns false.
   */
  cancel(): void {
    this.modalSrv.close(this.modalId, { key: 'cancel', value: false });
  }
}
